.styledModal {
  z-index: calc(var(--z-index-modal) + 1);

  [data-modal-container] {
    width: 95%;
    max-width: 600px;
    background: var(--background-soft);

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0 0 0 40px var(--background-soft) inset !important; /* stylelint-disable-line declaration-no-important */
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
